import CityPageTemplate from "../city-template/CityPageTemplate";
import { franklinNhConfig } from "./data";

export default function FranklinNHPage() {
  return <CityPageTemplate config={franklinNhConfig} />;
}